import { Observable } from 'rxjs';

export abstract class ImageProcessor {
  abstract process(data: Blob): Observable<Blob>;
}
